module.exports = "/_next/static/images/BadgeUnitedKingdom@2x-175fdf26bb522cf9eac7e09196795704.webp";